//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  props: ["Data"],
  data() {
    return {
      dataList: [],
      flag: false,
      swiperOption: {
        slidesPerView: 4,
        // spaceBetween: 30,
        slidesPerGroup: 4,
        // autoplay:true,
        speed: 1000,
        // loop: true,
        loopFillGroupWithBlank: true,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
      },
    };
  },
  watch: {
    Data() {
      this.dataList = this.Data;
    },
  },
  mounted() {
    var that = this;
    setTimeout(() => {
      that.flag = true;
      that.dataList = that.Data;
    }, 1000);
  },
};



// WEBPACK FOOTER //
// ./src/components/fuwu.vue